var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-secondary-navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"showDisabledNav")) {
output += "\n\n    <input type=\"text\" placeholder=\"";
output += runtime.suppressValue((lineno = 4, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search-mobile-category-placeholder-input"])), env.opts.autoescape);
output += "\" class=\"c-facets-link-small__placeholder-dropdown\" disabled />";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"))) {
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"hideNavigationAndFacets") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"showSecondaryNav")) {
output += "<nav class=\"o-secondary-navigation-outer c-category-navigation-outer\">\n\n        <h3 class=\"o-secondary-navigation__offscreen\">\n\n            ";
output += runtime.suppressValue((lineno = 14, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_categories-label"])), env.opts.autoescape);
output += "\n\n        </h3>\n\n        ";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large");
frame.set("isMediumScreenUp", t_1, true);
if(frame.topLevel) {
context.setVariable("isMediumScreenUp", t_1);
}
if(frame.topLevel) {
context.addExport("isMediumScreenUp", t_1);
}
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isMediumScreenUp")) {
output += "\n\n            <h3 class=\"c-category-navigation__heading\">\n\n                ";
output += runtime.suppressValue((lineno = 24, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_left-navigation-heading"])), env.opts.autoescape);
output += "\n\n            </h3>\n\n        ";
;
}
output += "\n\n        <div class=\"s-category-navigation o-secondary-navigation-inner c-category-navigation-inner js-dropdown-container\" role=\"menubar\" data-qa-navigation-categories>\n\n            ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSearch") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")) > 0) {
output += "\n\n                ";
var t_2;
t_2 = (lineno = 34, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"constants.selectedCategoryNavShowsChildren",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("useAlternateNavigation", t_2, true);
if(frame.topLevel) {
context.setVariable("useAlternateNavigation", t_2);
}
if(frame.topLevel) {
context.addExport("useAlternateNavigation", t_2);
}
output += "\n\n                ";
var t_3;
t_3 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"));
frame.set("categoryNavItem", t_3, true);
if(frame.topLevel) {
context.setVariable("categoryNavItem", t_3);
}
if(frame.topLevel) {
context.addExport("categoryNavItem", t_3);
}
output += "\n\n                ";
var t_4;
t_4 = env.getFilter("first").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs"));
frame.set("rootCrumb", t_4, true);
if(frame.topLevel) {
context.setVariable("rootCrumb", t_4);
}
if(frame.topLevel) {
context.addExport("rootCrumb", t_4);
}
output += "\n\n                ";
var t_5;
t_5 = env.getFilter("last").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs"));
frame.set("currentCrumb", t_5, true);
if(frame.topLevel) {
context.setVariable("currentCrumb", t_5);
}
if(frame.topLevel) {
context.addExport("currentCrumb", t_5);
}
output += "\n\n                ";
var t_6;
t_6 = (!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish") && (runtime.contextOrFrameLookup(context, frame, "currentCrumb") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")) > 1 && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug") == runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")),1)),"slug"))?"o-secondary-navigation__a--current":"");
frame.set("selectedClass", t_6, true);
if(frame.topLevel) {
context.setVariable("selectedClass", t_6);
}
if(frame.topLevel) {
context.addExport("selectedClass", t_6);
}
output += "\n\n                ";
var t_7;
t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryNavItem")),"nestLevel") == 2 && runtime.inOperator("marketing-root",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryNavItem")),"ancestorSlugs"));
frame.set("isL2WithMarketingRoot", t_7, true);
if(frame.topLevel) {
context.setVariable("isL2WithMarketingRoot", t_7);
}
if(frame.topLevel) {
context.addExport("isL2WithMarketingRoot", t_7);
}
output += "\n\n                <h3 class=\"o-secondary-navigation__h3 ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += " js-dropdown-toggle ";
;
}
output += "\" role=\"menuitem\" data-qa-parentcat>";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "<span class=\"o-secondary-navigation__a o-secondary-navigation__a--parent-category\">";
output += runtime.suppressValue((lineno = 50, colno = 109, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_shop-by"])), env.opts.autoescape);
output += "</span>\n\n                    ";
;
}
else {
output += "\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "useAlternateNavigation")) {
output += "\n\n                            ";
var t_8;
t_8 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryNavItem")),"itemId") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"itemId")?"o-secondary-navigation__a--current":"");
frame.set("alternateSelectedClass", t_8, true);
if(frame.topLevel) {
context.setVariable("alternateSelectedClass", t_8);
}
if(frame.topLevel) {
context.addExport("alternateSelectedClass", t_8);
}
output += "<a href=\"";
output += runtime.suppressValue((lineno = 58, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "categoryUrl"), "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"slug")])), env.opts.autoescape);
output += "\" class=\"o-secondary-navigation__a o-secondary-navigation__a--parent-category ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "alternateSelectedClass"), env.opts.autoescape);
output += "\"\n                                ";
output += runtime.suppressValue((lineno = 59, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 59, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"gaLabel")])), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"displayName"), env.opts.autoescape);
output += "</a>\n\n                        ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryNavItem")),"nestLevel") == 1 || runtime.contextOrFrameLookup(context, frame, "isL2WithMarketingRoot")) {
var t_9;
t_9 = (!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish") && (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentCrumb")),"slug") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"slug"))?"o-secondary-navigation__a--current":"");
frame.set("selectedRootClass", t_9, true);
if(frame.topLevel) {
context.setVariable("selectedRootClass", t_9);
}
if(frame.topLevel) {
context.addExport("selectedRootClass", t_9);
}
output += "\n                            <a href=\"";
output += runtime.suppressValue((lineno = 65, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "categoryUrl"), "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"slug")])), env.opts.autoescape);
output += "\" class=\"o-secondary-navigation__a o-secondary-navigation__a--parent-category ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selectedRootClass"), env.opts.autoescape);
output += "\"\n                                ";
output += runtime.suppressValue((lineno = 66, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 66, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"gaLabel")])), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rootCrumb")),"displayName"), env.opts.autoescape);
output += "</a>\n\n                        ";
;
}
else {
output += "\n\n                            ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")) > 1) {
output += "\n                                ";
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")),1);
frame.set("navItemCrumb", t_10, true);
if(frame.topLevel) {
context.setVariable("navItemCrumb", t_10);
}
if(frame.topLevel) {
context.addExport("navItemCrumb", t_10);
}
output += "\n                                <a href=\"";
output += runtime.suppressValue((lineno = 72, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "categoryUrl"), "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItemCrumb")),"slug")])), env.opts.autoescape);
output += "\" class=\"o-secondary-navigation__a o-secondary-navigation__a--parent-category ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selectedClass"), env.opts.autoescape);
output += "\"\n                                    ";
output += runtime.suppressValue((lineno = 73, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 73, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItemCrumb")),"gaLabel")])), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItemCrumb")),"displayName"), env.opts.autoescape);
output += "</a>\n\n                            ";
;
}
output += "\n\n                        ";
;
}
;
}
output += "\n\n                    ";
;
}
output += "\n\n                </h3>\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "useAlternateNavigation") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n\n                    ";
var t_11;
t_11 = 0;
frame.set("breadCrumbIndex", t_11, true);
if(frame.topLevel) {
context.setVariable("breadCrumbIndex", t_11);
}
if(frame.topLevel) {
context.addExport("breadCrumbIndex", t_11);
}
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 87, colno = 84, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "alternateCategoryFacetMacro")),"alternateBuildExplodedBreadcrumbNav"), "alternateCategoryFacetMacro[\"alternateBuildExplodedBreadcrumbNav\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs"),runtime.contextOrFrameLookup(context, frame, "breadCrumbIndex"),env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentCrumb")),"itemId"),runtime.makeKeywordArgs({"class": "secondary-navigation"})])), env.opts.autoescape);
output += "\n\n\n                ";
;
}
else {
output += "\n\n                    ";
var t_12;
t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryNavItem")),"nestLevel");
frame.set("categoryNestLevel", t_12, true);
if(frame.topLevel) {
context.setVariable("categoryNestLevel", t_12);
}
if(frame.topLevel) {
context.addExport("categoryNestLevel", t_12);
}
output += "\n                    ";
var t_13;
t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryNavItem")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryNavItem")),"childSlugs")) > 0;
frame.set("categoryHasChildren", t_13, true);
if(frame.topLevel) {
context.setVariable("categoryHasChildren", t_13);
}
if(frame.topLevel) {
context.addExport("categoryHasChildren", t_13);
}
output += "\n                    ";
var t_14;
t_14 = 1;
frame.set("breadCrumbIndex", t_14, true);
if(frame.topLevel) {
context.setVariable("breadCrumbIndex", t_14);
}
if(frame.topLevel) {
context.addExport("breadCrumbIndex", t_14);
}
output += "\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "categoryNestLevel") == 1 || (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish") && runtime.contextOrFrameLookup(context, frame, "categoryNestLevel") == 2 && !runtime.contextOrFrameLookup(context, frame, "categoryHasChildren") && !runtime.contextOrFrameLookup(context, frame, "isL2WithMarketingRoot"))) {
output += "\n                        ";
var t_15;
t_15 = 0;
frame.set("breadCrumbIndex", t_15, true);
if(frame.topLevel) {
context.setVariable("breadCrumbIndex", t_15);
}
if(frame.topLevel) {
context.addExport("breadCrumbIndex", t_15);
}
output += "\n                    ";
;
}
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 105, colno = 66, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "categoryFacetMacro")),"buildExplodedBreadcrumbNav"), "categoryFacetMacro[\"buildExplodedBreadcrumbNav\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs"),runtime.contextOrFrameLookup(context, frame, "breadCrumbIndex"),env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"breadcrumbs")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentCrumb")),"itemId"),runtime.makeKeywordArgs({"class": "secondary-navigation"})])), env.opts.autoescape);
output += "\n\n                ";
;
}
output += "\n\n            ";
;
}
output += "\n\n        </div>\n\n    </nav>";
;
}
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-secondary-navigation.j2"] , dependencies)